import { render, staticRenderFns } from "./SuccessPerson.vue?vue&type=template&id=26cc2aca&scoped=true&"
import script from "./SuccessPerson.vue?vue&type=script&lang=js&"
export * from "./SuccessPerson.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPerson.vue?vue&type=style&index=0&id=26cc2aca&prod&scoped=true&lang=css&"
import style1 from "./SuccessPerson.vue?vue&type=style&index=1&id=26cc2aca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cc2aca",
  null
  
)

export default component.exports